import React from 'react';
import { Box, Stack, Text } from '@atlaskit/primitives';

export const PaypalPaymentMethodInTable: React.FC<{ emailID: string }> = ({ emailID }) => {
  return (
    <Box>
      <Stack space="space.050">
        <Text size="medium">Paypal</Text>
        <Text size="small" color="color.text.subtlest">
          {emailID}
        </Text>
      </Stack>
    </Box>
  );
};
